var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
export const panelComments = (element) => {
  class PanelComments extends window.Decidim.CommentsComponent {
    _fetchComments(callback = null) {
      var _a;
      (_a = this.pendingRead) == null ? void 0 : _a.abort();
      window.Rails.ajax({
        url: this.commentsUrl,
        type: "GET",
        data: new URLSearchParams(__spreadValues({
          commentable_gid: this.commentableGid,
          root_depth: this.rootDepth,
          order: this.order
        }, this.toggleTranslations && {
          toggle_translations: this.toggleTranslations
        })),
        beforeSend: (xhr) => {
          this.pendingRead = xhr;
          return true;
        },
        success: () => {
          if (this.mounted) {
            return callback == null ? void 0 : callback();
          }
          return null;
        }
      });
    }
    _initializeSortDropdown() {
      this.sortListeners = [];
      this.$element[0].querySelectorAll(
        "[data-desktop-order-comment-select],[data-mobile-order-comment-select]"
      ).forEach((select) => {
        const handler = () => {
          this.order = select.value;
          this.reloadAllComments();
        };
        select.addEventListener("change", handler);
        this.sortListeners.push([select, handler]);
      });
    }
    unmountComponent() {
      var _a, _b;
      (_a = this.pendingRead) == null ? void 0 : _a.abort();
      (_b = this.sortListeners) == null ? void 0 : _b.forEach(
        ([select, handler]) => select.removeEventListener("change", handler)
      );
      super.unmountComponent();
    }
  }
  const wrapped = window.$(element);
  const instance = new PanelComments(wrapped, wrapped.data("decidim-comments"));
  wrapped.data("comments", instance);
  instance.mountComponent();
  return instance;
};
